module.exports = __webpack_public_path__ + "7179a12e139db0ff3b28f22e0b84cfcf.svg";